import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { canOperate } from "../lib/roles";
import { DARK } from "./seedance/constants";

// Guard de OPERADOR - espejo del server get_operator_user. A diferencia de
// ProductionRoute (admin+supervisor), admite tambien al editor (role `user`),
// porque la ingesta de shots es una accion de MIEMBRO del proyecto, no de
// produccion pura. Solo excluye asist_edit. La membresia real por-proyecto la
// valida el backend en POST /api/ingest (owner/member/admin). Se usa en
// /ingest para que un miembro no-supervisor no sea redirigido a `/`.
export default function OperatorRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div style={{
        minHeight: "100vh", background: DARK.bg, color: DARK.textDim,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'IBM Plex Sans','Helvetica Neue',sans-serif", fontSize: 13,
      }}>Loading…</div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!canOperate(user)) return <Navigate to="/" replace />;
  return children;
}
